import { render, staticRenderFns } from "./VaultItemCard.vue?vue&type=template&id=3f16e07f"
import script from "./VaultItemCard.vue?vue&type=script&lang=js"
export * from "./VaultItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports